export default {"src":"/_next/static/media/robust-analytics.1c1dc201.svg","height":42,"width":41,"blurWidth":0,"blurHeight":0};